import React from 'react';
import AppBar from '@mui/material/AppBar';
import { PinLogo } from '../../Assets/Img/PinLogo';
import './Header.component.scss';

export const HeaderComponent:React.FC = () => {
  return (
      <AppBar 
        className='px-2 px-lg-0' 
        color='transparent'
        sx={{ display: 'flex', alignItems:'center', position:'relative', margin:'0px' }}>
          <div className='header-content'>
            <PinLogo/>
          </div>
      </AppBar>
  );
}